<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">vip开通数据</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="进入时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>

        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            @cell-click="toggleSelection"
            :span-method="objectSpanMethod"
            :row-class-name="tableRowClassName"
            border
            v-loading="listLoading"
        >
          <!--          <el-table-column type="selection" width="55" />-->
          <el-table-column property="root" label="位置" v-if="checkColList.indexOf('位置') > -1"/>
          <el-table-column property="route" label="具体路径" v-if="checkColList.indexOf('具体路径') > -1" width="200">
            <template #default="scope">
              <p v-if="scope.row.route">{{scope.row.route}} ({{scope.row.id}})</p>
            </template>
          </el-table-column>
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"/>
          <el-table-column property="interva1" label="进入1小时内" v-if="checkColList.indexOf('进入1小时内') > -1" width="120"/>
          <el-table-column property="interva2" label="1-3小时" v-if="checkColList.indexOf('1-3小时') > -1"/>
          <el-table-column property="interva3" label="3-12小时" v-if="checkColList.indexOf('3-12小时') > -1"/>
          <el-table-column property="interva4" label="12-24小时" v-if="checkColList.indexOf('12-24小时') > -1"/>
          <el-table-column property="interva5" label="1-3天" v-if="checkColList.indexOf('1-3天') > -1"/>
          <el-table-column property="interva6" label="3-15天" v-if="checkColList.indexOf('3-15天') > -1"/>
          <el-table-column property="interva7" label="15-30天" v-if="checkColList.indexOf('15-30天') > -1"/>
          <el-table-column property="interva8" label="30-90天" v-if="checkColList.indexOf('30-90天') > -1"/>
          <el-table-column property="interva9" label="90-180天" v-if="checkColList.indexOf('90-180天') > -1"/>
          <el-table-column property="interva10" label="180-360天" v-if="checkColList.indexOf('180-360天') > -1"/>
          <el-table-column property="interva11" label="360-720天" v-if="checkColList.indexOf('360-720天') > -1"/>
          <el-table-column property="interva12" label="720天后" v-if="checkColList.indexOf('720天后') > -1"/>
          <el-table-column property="user_ratio" label="人次比列" v-if="checkColList.indexOf('人次比列') > -1">
            <template #default="scope">
              <p>{{scope.row.userRate}}<span v-if="scope.row.userRate > 0">%</span></p>
            </template>
          </el-table-column>
          <el-table-column property="money_ratio" label="金额比例" v-if="checkColList.indexOf('金额比例') > -1">
            <template #default="scope">
              <p>{{scope.row.moneyRate}}<span v-if="scope.row.moneyRate > 0">%</span></p>
            </template>
          </el-table-column>
        </el-table>
<!--        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--        </el-pagination>-->
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import BtnGroup from '../../components/BtnGroup'
import {gettVipStatLis} from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import RemarkDialog from "@/views/data/components/RemarkDialog";

export default {
  name: "DataVipOpen",
  components: { BtnGroup,DatePickerRange },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //刷新组
      colList: ['位置', '具体路径', '备注', '进入1小时内', '1-3小时', '3-12小时', '12-24小时', '1-3天', '3-15天', '15-30天', '30-90天', '90-180天', '180-360天','360-720天','720天后','人次比列','金额比例'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(gettVipStatLis, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          this.pageDataList.map(item => {
            item.rowNum = 0
            item.colNum = 0
          })
          for(let i=0; i<this.pageDataList.length; i++) {
            let num = this.pageDataList.filter(item => item.root == this.pageDataList[i].root).length
            this.pageDataList[i].rowNum = num
            this.pageDataList[i].colNum = 1
            i += (num - 1)
          }
          console.log(this.pageDataList)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {

      if(column.label == '备注') {
        if(row.rootNum){
          let listForm = {}
          listForm = Object.assign({}, row);
          Dialog.open({
            title: '编辑备注',
            component: RemarkDialog,
            data: {
              listForm: listForm,
              width: '500px'
            },
            confirm: (result) => {
              row.remark = result.remark
            }
          })
        }
      }

    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
          return {
            rowspan: row.rowNum,
            colspan: row.colNum
          };
        // if (rowIndex === 3 || rowIndex === 4 || rowIndex === 5 || rowIndex === 6 || rowIndex === 7 || rowIndex === 16 || rowIndex === 19 || rowIndex === 38 || rowIndex === 43 || rowIndex === 44 || rowIndex === 45 || rowIndex === 46 || rowIndex === 47 || rowIndex === 48 ) {
        //   return {
        //     rowspan: 1,
        //     colspan: 1
        //   };
        // }
        // if (rowIndex === 0) {
        //   return {
        //     rowspan: 3,
        //     colspan: 1
        //   };
        // } else if (rowIndex === 8){
        //   return {
        //     rowspan: 8,
        //     colspan: 1
        //   };
        // } else if (rowIndex === 17){
        //   return {
        //     rowspan: 2,
        //     colspan: 1
        //   };
        // }else if (rowIndex === 20){
        //   return {
        //     rowspan: 18,
        //     colspan: 1
        //   };
        // }else if (rowIndex === 39){
        //   return {
        //     rowspan: 4,
        //     colspan: 1
        //   };
        // }else {
        //   return {
        //     rowspan: 0,
        //     colspan: 0
        //   };
        // }
      }
    },

    tableRowClassName({row, rowIndex}) {
      if (row.root.indexOf('汇总') > -1) {
        return 'summary-row';
      }
      // else if (rowIndex === 42) {
      //   return 'all-summary-row'
      // }
      return '';
    },




  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.img-item {
  width: 40px;
  height: 40px;
}
.img-more {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  color: #c0c4cc;
  background-color: #f5f7fa;
}
</style>
